<template>
<div class="chapter">
<div class="inner_page">
<div id="id-3247496220690717658" style="height:0pt"></div>
<div class="titlepage" id="pgepubid00000">
<h1 class="calibre6">Be Young Again!</h1>
</div>
<div class="titlepage">
<h2 class="calibre sigil_not_in_toc" id="calibre_pb_3">Murray Leinster</h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?cec4a572